import React from 'react';
import * as M from '@mui/material';

export const BoxMsgComponent = M.styled(M.Box)(({ theme }) => ({
  maxWidth: '482px',
  fontFamily: 'AvenirNext-Medium',
  fontSize: '13.5px',
  fontWeight: 500,
  color: theme.palette.primary.textSecondary,
  borderRadius: '7.5px',
  borderBottomLeftRadius: 0,
  backgroundColor: '#f4f5f4',
  padding: '10px 15px',
  margin: '5px 0',
  wordBreak: 'break-all',
  display: 'inline-block',
  marginRight: 'auto',
  marginleft: '0px',
}));

export const BoxMsgTime = M.styled(M.Typography)(({ theme }) => ({
  fontFamily: 'AvenirNext-Medium',
  fontSize: '10px',
  fontWeight: 500,
  letterSpacing: 0.25,
  color: theme.palette.primary.textSecondary,
  lineHeight: 1.3,
}));

export const BoxMsgName = M.styled(M.Typography)(({ theme }) => ({
  fontFamily: 'AvenirNext-DemiBold',
  fontSize: '12px',
  fontWeight: 600,
  letterSpacing: 0.29,
  color: theme.palette.primary.textSecondary,
  lineHeight: 1.3,
  textTransform: 'capitalize',
}));

export const BoxMsgEvent = M.styled(M.Typography)(({ theme }) => ({
  fontFamily: 'AvenirNext-DemiBold',
  fontSize: '12px',
  fontWeight: 600,
  letterSpacing: 0.29,
  color: theme.palette.primary.textSecondary,
  lineHeight: 1.3,
  marginBottom: '5px',
}));

export const BoxMsgComponentDriver = M.styled(BoxMsgComponent)(({ theme }) => ({
  color: theme.palette.primary.textSecondary,
  background: '#e5e4fc',
  display: 'inline-block',
  marginRight: 'auto',
  marginleft: '0px',
}));

export const BoxMsgComponentMe = M.styled(BoxMsgComponent)({
  color: '#FFFFFF',
  background: '#8178ee',
  borderRadius: '7.5px',
  borderBottomRightRadius: 0,
  marginLeft: 'auto',
  marginRight: '0px',
  display: 'inline-block',
});

export const BoxMsgTimeMe = M.styled(BoxMsgTime)({
  textAlign: 'right',
});

export const BoxMsgNameMe = M.styled(BoxMsgName)({
  textAlign: 'right',
});

export const BoxLeaveNoteContainer = M.styled(M.Box)(({ theme }) => ({
  width: '300px',
  maxWidth: '100%',
  padding: '13px 22px',
  background: theme.palette.primary.grayEighth,
  border: `1px dotted ${theme.palette.primary.blackThird}`,
  fontFamily: 'AvenirNext-Medium',
  fontSize: '13px',
  fontWeight: 500,
  color: theme.palette.primary.blackThird,
  position: 'relative',
}));

export const BoxLeaveNoteTime = M.styled(M.Box)(({ theme }) => ({
  fontFamily: 'AvenirNext-DemiBold',
  fontSize: '12px',
  fontWeight: 600,
  textAlign: 'center',
  color: theme.palette.primary.blueLight,
  margin: '10px 0 15px',
}));

export const LeaveNoteIcon = M.styled(M.Box)(({ theme }) => ({
  width: '25px',
  height: '25px',
  borderRadius: '50%',
  backgroundSize: '32%',
  backgroundColor: theme.palette.primary.blackThird,
  backgroundImage: `url('/assets/images/svg/mail-attachment-3.svg')`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  position: 'absolute',
  top: '0px',
  left: -15,
  bottom: '0px',
  margin: 'auto 0',
}));

export const BoxFeedbackContainer = M.styled(BoxLeaveNoteContainer)(({ status, theme }) => ({
  border: 'none',
  margin: '0 auto',
}));

export const BoxFeedbackTime = M.styled(BoxLeaveNoteTime)(({ theme }) => ({}));

export const BoxGoodFeedbackIcon = M.styled(LeaveNoteIcon)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.primary.green,
  backgroundImage: `none`,
}));

export const BoxGoodNoFeedbackIcon = M.styled(BoxGoodFeedbackIcon)(({ theme }) => ({
  left: '0px',
  right: '0px',
  margin: 'auto',
}));

export const BoxBadFeedbackIcon = M.styled(BoxGoodFeedbackIcon)(({ theme }) => ({
  backgroundColor: theme.palette.primary.redSecond,
}));

export const BoxBadNoFeedbackIcon = M.styled(BoxBadFeedbackIcon)(({ theme }) => ({
  left: '0px',
  right: '0px',
  margin: 'auto',
}));
